import type { ActivityModule } from '../../core/activity';
import { runMemoryMathActivity, type MemoryMathLevelsFile } from '../../shared/memory-math-runner';
import levelsData from './levels.json';

const LEVELS = (levelsData as MemoryMathLevelsFile).levels;

export const memoryMathMult: ActivityModule = {
  id: 'memory-math-mult',
  title: 'Memória — Multiplicação',
  description: 'Jogo da memória onde cada par é formado por uma expressão (ex: 3×4) e seu resultado (12). Treine a tabuada de multiplicação.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/memory-math-mult/icon.svg',
  category: 'memoria',
  totalLevels: LEVELS.length,
  mount: (ctx) =>
    runMemoryMathActivity(ctx, {
      activityId: 'memory-math-mult',
      title: 'Memória — Multiplicação',
      hint: 'Encontre o par: expressão ↔ resultado.',
      levels: LEVELS,
    }),
};
